var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from 'react';
import { useReport } from '@tencent/dz-report';
import { useMobileModel, useMessageById } from '../../../hooks';
export var useReportService = function (messageId) {
    var report = useReport();
    var _a = useMobileModel(), autoPhoneEnabled = _a.autoPhoneEnabled, mobile = _a.mobile;
    var messageState = useMessageById(messageId);
    var _b = messageState.msg_content, msgContent = _b === void 0 ? '' : _b, payload = messageState.payload;
    var commonParams = {
        module_id: '',
        module_value: msgContent || '',
        module_type: (payload === null || payload === void 0 ? void 0 : payload.is_offline) ? 'offline_message' : 'message',
        module_chinese_type: (payload === null || payload === void 0 ? void 0 : payload.is_offline) ? '离线消息' : '消息',
    };
    useEffect(function () {
        quickPhoneExposure();
    }, []);
    var quickPhoneExposure = function () {
        report.exposure(__assign(__assign({}, commonParams), { element_id: msgContent, element_type: 'quick_send_phone', element_chinese_type: '一键发送手机号', element_content: msgContent }));
        if (autoPhoneEnabled) {
            report.exposure(__assign(__assign({}, commonParams), { element_id: msgContent, element_type: 'quick_send_phone_authorize_clause', element_chinese_type: '一键发送手机号_授权条款', element_content: '' }));
        }
    };
    var quickPhonePopupExposure = function () {
        report.exposure(__assign(__assign({}, commonParams), { element_id: msgContent, element_type: 'quick_send_phone_popup', element_chinese_type: '一键发送手机号_弹窗' }));
    };
    var quickPhoneSubmit = function (phone) {
        report.click(__assign(__assign({}, commonParams), { element_id: mobile, element_type: 'quick_send_phone_send', element_chinese_type: '一键发送手机号_发送', element_content: phone }));
    };
    var quickPhoneClauseClick = function (checked) {
        report.click(__assign(__assign({}, commonParams), { element_id: msgContent, element_type: 'quick_send_phone_authorize_clause', element_chinese_type: '一键发送手机号_授权条款', element_content: checked ? '是' : '否' }));
    };
    var quickPhonePopupSubmit = function (phone) {
        quickPhoneClauseClick(true);
        report.click(__assign(__assign({}, commonParams), { element_id: mobile, element_type: 'quick_send_phone_popup_send', element_chinese_type: '一键发送手机号_弹窗_发送', element_content: phone }));
    };
    var quickPhonePopupCancel = function () {
        report.click(__assign(__assign({}, commonParams), { element_id: msgContent, element_type: 'quick_send_phone_popup_cancel', element_chinese_type: '一键发送手机号_弹窗_取消' }));
    };
    return {
        quickPhoneExposure: quickPhoneExposure,
        quickPhonePopupExposure: quickPhonePopupExposure,
        quickPhoneSubmit: quickPhoneSubmit,
        quickPhoneClauseClick: quickPhoneClauseClick,
        quickPhonePopupSubmit: quickPhonePopupSubmit,
        quickPhonePopupCancel: quickPhonePopupCancel,
    };
};
